<template>
<div>
  <span v-if="feature == 'salary'"
        class="text-primary">Расчет зарплаты</span>
  <span v-if="feature == 'vacation'"
        class="text-success">Отпускные</span>

  <span v-if="feature == 'additionalvacation'"
        class="text-success">Дополнительные отпускные</span>

  <span v-if="feature == 'compensationvacation'"
        class="text-success">Компенсация отпуска</span>
  <span v-if="feature == 'hospital'"
        class="text-success">Расчет больничных</span>
  <span v-if="feature == 'merged'"
        class="text-danger">Объединенное начисление</span>
</div>
</template>


<script>
export default {
  name: 'feature',
  props: ['feature']
}
</script>


<style>

</style>